import React from "react";
import { Box, Typography, Stack, Button, Avatar, IconButton, Chip } from "@mui/material";
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { useNavigate } from "react-router-dom";

const formatIstihdamTuru = (v) =>
  v ? v.split("_").map((w) => w[0].toUpperCase() + w.slice(1)).join(" ") : "-";

const EmployeeHeader = ({ fullName, initials, employee, onEdit, onToggleActive }) => {
  const navigate = useNavigate();
  const isAktif = employee?.aktif ?? true;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mb: 3,
        bgcolor: "white",
        p: 3,
        borderRadius: 2,
        boxShadow: 1,
      }}
    >
      <IconButton onClick={() => navigate("/personel")} sx={{ mr: 1 }}>
        <KeyboardReturnIcon />
      </IconButton>

      <Avatar
        sx={{
          width: 56,
          height: 56,
          bgcolor: isAktif ? "#3B82F6" : "#9CA3AF",
          mr: 2,
          transition: "background-color 0.3s",
        }}
      >
        {initials}
      </Avatar>

      <Box sx={{ flex: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="h6" fontWeight="bold">
            {fullName}
          </Typography>
          <Chip
            size="small"
            label={isAktif ? "Aktif" : "Pasif"}
            color={isAktif ? "success" : "default"}
            variant="outlined"
            sx={{ fontWeight: 600 }}
          />
        </Box>
        {employee && (
          <Typography variant="body2" color="text.secondary">
            {formatIstihdamTuru(employee.istihdam_turu)}
          </Typography>
        )}
      </Box>

      <Stack direction="row" spacing={1}>
        <Button
          variant="outlined"
          size="small"
          color={isAktif ? "error" : "success"}
          onClick={onToggleActive}
        >
          {isAktif ? "Pasife Al" : "Aktife Al"}
        </Button>
      </Stack>
    </Box>
  );
};

export default EmployeeHeader;